import React, { useState } from "react";
import { Button, Box, Modal, CircularProgress } from "@mui/material";
import { FaEye } from "react-icons/fa";

const ViewButton = ({ filePath }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleLoad = () => setLoading(false);

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          marginLeft: "5px",
          backgroundColor: "rgb(124, 46, 160)",
          fontSize: 14,
          width: "160px",
          height: "36px",
          textTransform: "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FaEye color="#FFF" size={20} />
          VIEW SOW
        </div>
      </Button>

      <Modal open={open} onClose={handleClose} style={{ zIndex: 99999 }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                bgcolor: "rgba(255,255,255,0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <CircularProgress size={50} color="primary" />
            </Box>
          )}
          <iframe
            src={filePath}
            width="100%"
            height="100%"
            title="PDF Viewer"
            style={{ border: "none", flexGrow: 1 }}
            onLoad={handleLoad}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleClose}
              sx={{ width: "150px" }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewButton;
